import { createSelector } from 'reselect';
import { getName } from 'conversations-internal-schema/inbox/operators/inboxGetters';
import { getCurrentInbox } from './getCurrentInbox';
export const getCurrentInboxName = createSelector([getCurrentInbox], getName);